import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'Tennis Channel',
    callsign: 'TENISHD',
    logoUrl: networkLogos.tennischannel.logoUrl,
    slug: 'tennis-channel',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="TENISHD"
        title="Watch Tennis Channel live with Fubo"
        networkName="Tennis Channel"
      />
    </>
  )
}
